import React from "react";

/**
 * Arrow-right icon used on the CTAs and the "Anmelden" link (matches the design's
 * inline SVG: stroke=currentColor so it inherits the button/link text color).
 */
const ArrowRight = ({ size = 15 }) => (
    <svg
        className="registration-arrow"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
    >
        <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
);

export default ArrowRight;
